import {Component, OnInit} from "@angular/core";
import {UmRoleObjectBaseComponent} from "../um-role-object-base.component";

@Component({
    selector: "um-role-object-side",
    templateUrl: "./um-role-object-side.component.html",
    standalone: false
})

export class UmRoleObjectSideComponent extends UmRoleObjectBaseComponent implements OnInit {


    ngOnInit() {
        super.ngOnInit();
    }
}
